import { createFileRoute } from '@tanstack/react-router';
import WebManagement from '../../components/manager/WebManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/web')({
  component: WebManagementRoute,
});

function WebManagementRoute() {
  return (
    <ManagerPortal>
      <WebManagement />
    </ManagerPortal>
  );
}
